import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ca5a708&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7ca5a708&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca5a708",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca5a708')) {
      api.createRecord('7ca5a708', component.options)
    } else {
      api.reload('7ca5a708', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7ca5a708&scoped=true", function () {
      api.rerender('7ca5a708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hotpotModal/index.vue"
export default component.exports